import {
  AvailabilityFormDrawerEnabledFields,
  NewAvailabilityEntry,
} from 'pages/Availability/common/FormDrawer/types';
import { AvailabilityReason } from 'pages/Availability/types';

export const getEnabledFormFields = (
  availabilityEntry: NewAvailabilityEntry<AvailabilityReason> | null,
  isEdit: boolean,
): AvailabilityFormDrawerEnabledFields => {
  if (!availabilityEntry || !isEdit) {
    return {
      start: true,
      end: true,
      isOpenEnded: true,
      startImmediately: true,
      repeatDaily: true,
      repeatEndInclusive: true,
      availabilityReason: true,
      notes: true,
      maxImportPower: true,
      maxExportPower: true,
      energyCapacity: true,
    };
  }

  const hasStarted = new Date(availabilityEntry.start ?? '') < new Date();
  const hasEnded = availabilityEntry.end
    ? new Date(availabilityEntry.end ?? '') < new Date()
    : false;

  return {
    start: !hasStarted,
    end: !hasEnded,
    isOpenEnded: false,
    startImmediately: false,
    repeatDaily: false,
    repeatEndInclusive: false,
    availabilityReason: false,
    notes: true,
    maxImportPower: false,
    maxExportPower: false,
    energyCapacity: false,
  };
};
